import { getAuthUrls } from "~/lib/utils";
import { Button } from "~/components/atoms/Button";
import Star from "~/components/atoms/Star";
import { Form, Link, useFetcher, useLocation } from "react-router";

export const CollegeSignUpModalContent = ({
    collegeName,
    collegeId,
}: {
    collegeName: string;
    collegeId: string;
}) => {
    const fetcher = useFetcher({ key: "data-processor" });
    const location = useLocation();
    const { signUp, login } = getAuthUrls({ returnTo: `${location.pathname}${location.search}` });

    const onClick = () => {
        void fetcher.submit(
            { favoritedCollegeId: collegeId },
            { method: "post", action: "/college-recruiting/metadata" },
        );
    };
    return (
        <section className="flex flex-col items-center gap-[40px]">
            <Star size="xl" fill="blue" outline="blue" />

            <p className="text-center font-condensed text-2xl font-extrabold uppercase leading-normal text-blue-80">
                Create a free account
                <br />
                to save this college
            </p>
            <span className="text-center text-base font-bold text-blue-80">{collegeName}</span>
            <Form action={signUp} method="post">
                <Button
                    type="submit"
                    onClick={onClick}
                    buttonStyle="primary"
                    className="min-h-[45px]"
                >
                    Create a Free Account
                </Button>
            </Form>
            <div className="text-center">
                <span className="text-base font-normal text-blue-80">
                    Already have an account?&nbsp;
                </span>
                <Form action={signUp} method="post" className="inline-flex">
                    <Link
                        type="submit"
                        to={login}
                        onClick={onClick}
                        className="min-h-[45px] text-base font-bold text-blue-80"
                    >
                        Log In
                    </Link>
                </Form>
            </div>
        </section>
    );
};
CollegeSignUpModalContent.displayName = "CollegeSignUpModalContent";
